import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'
import { filterBreadsByCategory } from 'lib/filter'
import { CategoryType } from 'types/category'
import { BreadType } from 'types/bread'

const useHandleKeyword = (
  breads: BreadType[],
  categories: CategoryType[],
  categoryName: string,
  setKeyword: Dispatch<SetStateAction<string>>,
  setBreadList: Dispatch<SetStateAction<BreadType[]>>
) => {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      // 空白であればカテゴリーのみのフィルタリング
      if (value === '') {
        const filteredBreadsByCategory = filterBreadsByCategory(categoryName, categories, breads)
        setBreadList([...filteredBreadsByCategory])
      }
      setKeyword(value)
    },
    [breads, categories, categoryName, setKeyword, setBreadList]
  )
}

export default useHandleKeyword
